import {
  APIKEY_SET_GRID,
  APIKEY_SET_DATA,
  APIKEY_SET_DATA_ALL,
  APIKEY_SET_LAST_PAGE,
  APIKEY_SET_TOTAL_ROWS,
  APIKEY_SET_RELOAD_DATA,
  APIKEY_SET_LOADING,
  APIKEY_SET_LOADING_ALL,
  APIKEY_TOGGLE_REVOKE_CONFIRM_MODAL,
  APIKEY_TOGGLE_CREATE_OR_ADD_MODAL,
  APIKEY_SET_CURRENT_ROW,
} from './enums/Types';

const initialState = {
  grid: {
    data: [],
    currentPage: 1,
    lastPage: 0,
    firstItem: 0,
    lastItem: 0,
    reloadData: 0,
    hasMorePages: false,
    total: 0,
    loading: false,
  },
  createOrEditModal: false,
  revokeConfirmModal: false,
  currentRow: {},
};

const ApiKeyReducer = (state = initialState, action) => {
  switch (action.type) {
    case APIKEY_SET_GRID:
      return { ...state, grid: action.data };
    case APIKEY_SET_DATA_ALL:
      return { ...state, dataAll: action.data };
    case APIKEY_SET_LOADING:
      return { ...state, grid: { ...state.grid, loading: action.value } };
    case APIKEY_SET_LOADING_ALL:
      return { ...state, loadingAll: action.value };
    case APIKEY_SET_RELOAD_DATA:
      return {
        ...state,
        grid: { ...state.grid, reloadData: state.grid.reloadData + 1 },
      };
    case APIKEY_SET_CURRENT_ROW:
      return { ...state, currentRow: action.data };
    case APIKEY_TOGGLE_REVOKE_CONFIRM_MODAL:
      return { ...state, revokeConfirmModal: !state.revokeConfirmModal };

    case APIKEY_TOGGLE_CREATE_OR_ADD_MODAL:
      return { ...state, createOrEditModal: !state.createOrEditModal };

    default:
      return state;
  }
};
export default ApiKeyReducer;
